import React from 'react';
const LOGOS: {
  src: string;
  alt: string;
}[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/rUyUR5qinrYADH1xGAcoFN/Og9d7AnszqJlPJmuxePz6WPLw_(1).png',
  alt: 'Logo partenaire'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/woqi7DxuTGaDe3dVSpE4nV/paebyQ5F4q2FC5GN3oBjHjr15I.png',
  alt: 'Engie'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/feK4MTmp99nKmnEnuU9QPV/qZTlDm9uAGciMLAdsfkeFP9d30.png',
  alt: 'Burger King'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oW65yXeu3SSU4rKegUy3uA/xFNXNoPscuzHVrFjpvOGXhpjsdw.png',
  alt: 'Media6'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ewSFv5V5SRAL5YzLemtnak/cdpK56oqxardUSstRrjGbEGc4c.png',
  alt: 'St Maclou'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9x3K6gFoMfb59orXMZqGb7/i3HH6IllawphtRIuQT6VHqiatg.png',
  alt: 'E.Leclerc'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eT2RNxc5M8U86fLB4vRrz7/iVNJxlexndnGfXeqq00nSicUGN4.png',
  alt: 'Outsourcia'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nVcHUwPpNowmiFA5xDDBny/KX5HfBlS4Kvnbd1YWG8PFWcihE.png',
  alt: 'Partenord Habitat'
}];
export function LogoMarquee() {
  return <div className="rewayz-marquee group relative w-full overflow-hidden" data-id="element-28">
      {/* Edge fades */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-blue-reways-950-lock to-transparent" data-id="element-29" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-blue-reways-950-lock to-transparent" data-id="element-30" />

      <ul className="rewayz-marquee-track flex w-max items-center gap-12" data-id="element-31">
        {[...LOGOS, ...LOGOS].map((logo, i) => <li key={i} className="flex flex-none items-center" aria-hidden={i >= LOGOS.length} data-id="element-32">
            <img src={logo.src} alt={i < LOGOS.length ? logo.alt : ''} className="h-7 w-auto object-contain opacity-70 sm:h-8" data-id="element-33" />
          </li>)}
      </ul>
    </div>;
}